import React from 'react';
import PropTypes from 'prop-types';
import { AUIModal } from '@ancert/aui-modal';
import { ReactComponent as IconWarning } from '../../../../assets/images/ic-warning.svg';
import './ModalErrorGenerico.scss';

/**
 * Modal para mostrar error genérico
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @returns {React.ReactElement} - Componente ModalErrorGenerico
 */
const ModalErrorGenerico = ({ show, onClose }) => (
  <AUIModal
    autoHeight
    size="sm"
    show={show}
    actionButtons={[
      {
        value: 'tertiary',
        mode: 'tertiary',
        label: 'Volver',
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <div className="modal-content">
      <IconWarning />
      <p>Ha ocurrido un problema. Intentelo de nuevo.</p>
    </div>
  </AUIModal>
);

ModalErrorGenerico.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalErrorGenerico;
